const ADDITIONAL_FIELD_OPTIONS = [
  {
    label: 'Text Input',
    value: 'textfield',
    type: 'textfield',
  },
  {
    label: 'Text Area',
    value: 'textarea',
    type: 'textarea',
  },
  {
    label: 'Mailing Address',
    value: 'address',
    type: 'address',
  },
  {
    label: 'Numeric Input',
    value: 'number',
    type: 'number',
  },
  {
    label: 'Currency Input',
    value: 'dollar',
    type: 'dollar',
  },
  {
    label: 'Selection List',
    value: 'dropdown',
    type: 'dropdown',
  },
  {
    label: 'Date',
    value: 'date',
    type: 'date',
  },
  {
    label: 'Multiselect',
    value: 'multiselect',
    type: 'multiselect',
  },
  {
    label: 'Checkbox',
    // dev note: this `value` was changed from `checkbox` to `boolean`,
    // since the `checkbox` type was deprecated in the backend and isn't accepted.
    // The corresponding field in ../AdditionalFieldsForm.tsx was also updated to use `boolean`
    value: 'boolean',
    type: 'boolean',
  },
] as const;

const MAILING_ADDRESS_LABEL = 'Mailing Address';
export { ADDITIONAL_FIELD_OPTIONS, MAILING_ADDRESS_LABEL };
